import React from "react";

const IMAGES = [
  {
    src: "https://images.pexels.com/photos/7750124/pexels-photo-7750124.jpeg?auto=compress&cs=tinysrgb&w=1400",
    label: "Our Salon",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1772322586754-34c9e6f5be6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxuYWlsJTIwYXJ0JTIwbWFuaWN1cmUlMjBzYWxvbnxlbnwwfHx8fDE3Nzg0ODc4NjB8MA&ixlib=rb-4.1.0&q=85",
    label: "Nail Couture",
  },
  {
    src: "https://images.unsplash.com/photo-1740297165018-1431d45d8f11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHx3b21hbiUyMHNwYSUyMGZhY2lhbCUyMG1hc3NhZ2UlMjByZWxheGluZ3xlbnwwfHx8fDE3Nzg0ODc4NjB8MA&ixlib=rb-4.1.0&q=85",
    label: "Facial Ritual",
  },
  {
    src: "https://images.pexels.com/photos/3993290/pexels-photo-3993290.jpeg?auto=compress&cs=tinysrgb&w=900",
    label: "Hair Styling",
  },
  {
    src: "https://images.pexels.com/photos/19239114/pexels-photo-19239114.jpeg?auto=compress&cs=tinysrgb&w=900",
    label: "Laser · Legs",
  },
  {
    src: "https://images.pexels.com/photos/16032298/pexels-photo-16032298.jpeg?auto=compress&cs=tinysrgb&w=900",
    label: "Laser · Arms",
  },
  {
    src: "https://images.pexels.com/photos/16032366/pexels-photo-16032366.jpeg?auto=compress&cs=tinysrgb&w=900",
    label: "Laser · Smooth Skin",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/25f97584-112a-47b2-84d3-7d9ab16d2f41/images/ccb92beaded7deb5c13477dbdc139faa71eae494eace746acbc8810891ba5db5.jpeg",
    label: "Laser · Brazilian",
    span: "md:col-span-2",
  },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <div className="eyebrow mb-4">The Atelier</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
              A studio designed
              <br />
              <span className="italic text-[#FF2079]">to make you feel rare.</span>
            </h2>
          </div>
          <p className="text-[#A09CA3] text-base leading-relaxed max-w-md">
            Step into our private space, where every detail — from the lighting
            to the linens — was crafted to feel like an indulgent escape.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
          {IMAGES.map((img) => (
            <div
              key={img.label}
              data-testid={`gallery-item-${img.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`relative overflow-hidden rounded-sm group cursor-pointer ${img.span || ""}`}
            >
              <img
                src={img.src}
                alt={img.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-4 left-4 right-4">
                <div className="font-display text-xl md:text-2xl text-white">
                  {img.label}
                </div>
              </div>
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10 group-hover:ring-[#FF2079]/40 transition-all" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
